<template>
    <div class="news">
      <div class="banner">
        <el-image :src="require('../../assets/home/news.png')" class="banner-img"></el-image>
      </div>
      <div class="tag">
        <div class="title">
          <div class="slogan">新闻中心 </div>
          <div class="sloganen">NEWS CENTER</div>
        </div>
      </div>


      <div id="about-meau">
        <el-tabs v-model="activeName" @tab-click="newsMenuSelect">
        <el-tab-pane v-for="item in menus" :key="item.id" :name="item.type" :label=" item.name"  >
          <span v-show="tag==1"> {{ item.name }}</span>
        </el-tab-pane>
        </el-tabs>
      </div>
      <div class="new-list" v-show="tag==1">
          <el-row :gutter="10" v-for ="(news, index) in newsList" :key="index"  class="xuxian">
              <el-col  :lg="8" >
                  <el-image fit="fill" :src="imageUrl+news.img" class="grid-content"></el-image>
              </el-col>
              <el-col  :lg="15"  :offset="1">
                <div class="grid-content">

                    <el-row :gutter="20">
                    <el-col :span="24"><div class="news-title">{{news.title}}</div></el-col>
                    </el-row>
                    <el-row :gutter="20">
                    <el-col :span="24" >
                      <div class="news-summary">&#12288;&#12288;{{news.summary.slice(0,80)}}......
                      <el-link type="primary" :underline="false"  @click="openNews(news.id)">【详细】</el-link></div>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20">
                    <el-col :span="5" :offset="19"><div class="news-time">{{news.creatDate.slice(0,10)}}</div></el-col>
                    </el-row>
                </div>
                </el-col>
          </el-row>
      </div>
        <div class="new-info" v-show="tag==2">
              <span class="new-info-title">{{newsinfo.title}}</span>

              <p class="ql-editor" v-html='newsinfo.content'></p>
         
        </div>
    </div>

</template>
<script>
import { getRequest } from "../../util/api";
import VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css'
export default {
  data() {
    return {
      menus: [],
      newsList:[],
      content: "",
      activeName: '',
      imageUrl:'',
      tag:1,
      newsinfo:"",
    };
  },
  mounted() {
    this.getMenuChildren();
    this.activeName=this.$route.query.id;
    if(this.$route.query.contentId){
      this.tag=2;
      this.openNews(this.$route.query.contentId)
    }else{
      if ('company'==this.$route.query.id){
        this.getList(1)
        this.tag=1; 
      }else{
        this.getList(2)
        this.tag=1;
      }
    }
  },
    watch: {
    activeName(newVal) {
      this.$router.push({
        query: {id:`${this.activeName}`}
      })
    },
    '$route.query.id':function(newVal){
        this.activeName=newVal;
        if ('company'==newVal){
        this.getList(1)
        this.tag=1;
      }else{
        this.getList(2)
        this.tag=1;

      }
    }
  },
  methods: {
     newsMenuSelect(tab, event) {
         let that = this
         if ('company'==tab.name){
           that.getList(1); 
            that.tag=1;
         }else{
            that.getList(2); 
             that.tag=1;
         }
    },
    getMenuChildren() {
      let that = this;
      let params = {
        pid: 4
      };
      getRequest("/menus/type", params).then(function(res) {
        if (res.data.meta.code == 1) {
          console.log("进来了hah");
          that.menus = res.data.data;
        }
      });
    },
     getList(key) {
      let origin = document.location.origin
      let that = this
      that.imageUrl='http://www.lensyn.com:8088/';
      let params = {
        type: key,
        keyWords: that.keyWords,
        pageStart: 0,
        pageSize: 1000
      }
      getRequest('/news/list', params).then(function(res) {
        if (res.data.meta.code === 1) {
          that.newsList = res.data.data
        }
      })
    },
    openNews(id){
      let that = this
      that.tag=2
       
      let params = {
        id: id
      }
       getRequest('/news/content', params).then(function(res) {
          
          that.newsinfo = res.data.data
        
       })
    }
  }
};
</script>
<style >

.new-info-title{
  text-align: center;
  display:block;
  font-weight:500;
  font-size: 24px;
  line-height: 36px;
}
.news-title{
  min-height: 35px;
  color: #0E2336;
  font-size: 20px;
  line-height: 35px;
  font-weight: 800;
}
.news-summary{
  min-height: 130px;
  color: #0E2336;
  font-size: 16px;
  line-height: 40px;
  font-weight: 400;
}

  .grid-content {
    height: 190px;
    margin-bottom: 10px;
  }

.new-info{
  padding-bottom: 50px;
  padding-top: 25px;
  height: auto;
  width: 80%;
  margin: auto; 
}

.news {
  width: 99%;
}
/* .new-info img{
width: 100%;
height: 100%;
} */
</style>
<style src="../../css/banner.css"></style>


// WEBPACK FOOTER //
// src/components/content/News.vue